import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import isPrivateRoute from 'router/helpers/isPrivateRoute';
import { PRIVATE, PUBLIC } from 'router/constants/routes';

import { getToken, removeToken, setToken } from 'api/utils/tokenManagement';

import { setUrlParams } from 'store/user/actions';
import {
  authentication,
  authenticationBySignature,
  setAuthenticationStatus,
  setAuthRedirectUrl,
} from 'store/auth/actions';

import { AUTH_TOKEN_NAME } from 'constants/api';
import { accountTabs } from 'constants/account';

import { initHotjar } from 'services/Hotjar';
import { initAnalytics } from 'services/analytics/initAnalytics';
import { sendAnalyticCabinetStartSession } from 'services/analytics';

import { useDispatch } from 'hooks/store';

import { getUrlParams } from 'helpers/utils';

const USER_ID_PARAM_NAME = 'c';
const SIGNATURE_PARAM_NAME = 'sg';

export const useAuthentication = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search, pathname } = useLocation();

  const isPrivate = isPrivateRoute(pathname);

  const params = new URLSearchParams(search);

  useEffect(() => {
    const urlParamsFromURL = getUrlParams();

    const uId = params.get(USER_ID_PARAM_NAME);
    const signature = params.get(SIGNATURE_PARAM_NAME);

    initAnalytics();
    initHotjar();

    sendAnalyticCabinetStartSession();

    if (uId && signature) {
      const subscriptionsPage = `${PRIVATE.ACCOUNT_DEFAULT.path}/${accountTabs.Subscription}`;

      dispatch(setAuthRedirectUrl(subscriptionsPage));
      dispatch(
        authenticationBySignature({
          uId,
          signature,
          onSuccess: () => {
            dispatch(setUrlParams(urlParamsFromURL));

            navigate(subscriptionsPage);
          },
          onError: () => {
            navigate(PUBLIC.LOGIN.path);
          },
        })
      );

      return;
    }

    const tokenFromUrl = params.get(AUTH_TOKEN_NAME);

    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    }

    if (!getToken()) {
      isPrivate && dispatch(setAuthRedirectUrl(pathname));

      dispatch(setAuthenticationStatus(false));

      return;
    }

    dispatch(
      authentication({
        onSuccess: () => {
          navigate(pathname);
        },
        onError: () => {
          removeToken();
          isPrivate && dispatch(setAuthRedirectUrl(pathname));
          navigate(PUBLIC.LOGIN.path);
        },
      })
    );
  }, []);
};
